import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  --buttonBgColor: ${brand.green};
  --buttonFgColor: ${brand.white};
  --thumbBorder: ${brand.green};
  --thumbColor: ${brand.white};
  --trackColor: #c0c0c0;
  --trackFillColor: ${brand.green};

  display: flex;
  align-items: center;
  margin: 0 0 50px;

  @media ${from(Device.TabletLarge)} {
    --buttonBgColor: ${brand.white};
    --buttonFgColor: ${brand.black};
    --thumbBorder: ${brand.white};
    --thumbColor: #ced6cb;
    --trackColor: ${rgba(brand.white, 0.5)};
    --trackFillColor: ${brand.white};
  }
`;
const Input = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  appearance: none;
  background: none;
  flex: 1 1 auto;
  height: 32px;
  margin: 0 12px;
  max-width: 254px;
  width: 100%;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    background: var(--trackColor);
    border: 0;
    border-radius: 0;
    box-shadow: none;
    cursor: pointer;
    height: 3px;
    width: 100%;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    background: var(--thumbColor);
    box-shadow: none;
    border: 2px solid var(--thumbBorder);
    border-radius: 12px;
    cursor: pointer;
    height: 24px;
    margin-top: -11.5px;
    width: 24px;
  }

  &:focus::-webkit-slider-runnable-track {
    background: var(--trackColor);
  }

  &::-moz-range-track {
    background: var(--trackColor);
    border: 0;
    border-radius: 0;
    box-shadow: none;
    cursor: pointer;
    height: 3px;
    width: 100%;
  }

  &::-moz-range-thumb {
    background: var(--thumbColor);
    border: 2px solid var(--thumbBorder);
    border-radius: 12px;
    box-shadow: none;
    cursor: pointer;
    height: 24px;
    width: 24px;
  }

  &::-moz-range-progress {
    background: var(--trackFillColor);
  }
`;
const Button = styled.button `
  display: flex;
  background: var(--buttonBgColor);
  border: 0;
  color: var(--buttonFgColor);
  flex: 0 0 auto;
  height: 40px;
  place-content: center;
  place-items: center;
  width: 40px;
`;
const RangeSliderStyles = {
    Button,
    Container,
    Input,
};
export default RangeSliderStyles;
